// components/forms/RegisterForm/steps/OTPVerificationStep.jsx
import React from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress
} from '@mui/material';

const OTPVerificationStep = ({ 
  onSubmit, 
  isLoading = false, 
  otpData = { enteredOtp: '' }, 
  onOtpChange = () => {}, // ✅ Safe default
  onResendOTP = () => {}, // ✅ Safe default
  mobile = '',
  errors ={}
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  const handleOtpInputChange = (e) => {
    const value = e.target.value.slice(0, 4);
    if (typeof onOtpChange === 'function') {
      onOtpChange(value);
    }
  };



  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <Typography variant="h6" gutterBottom align="center">
        OTP Verification
      </Typography>
      
      <Typography variant="body1" color="text.secondary" align="center" sx={{ mb: 3 }}>
        We've sent a 4-digit OTP to your mobile number ending with 
        <strong> {mobile?.slice(-3)}</strong>
      </Typography>

      <TextField
        fullWidth
        label="Enter OTP"
        type="number"
        value={otpData.enteredOtp || ''}
        onChange={handleOtpInputChange}
        inputProps={{ 
          maxLength: 4,
          pattern: '[0-9]*',
          inputMode: 'numeric'
        }}
        placeholder="Enter 4-digit OTP"
        sx={{ mb: 2 }}
        disabled={isLoading}
        error={!!errors.enteredOtp} // ✅ Show error state
        helperText={errors.enteredOtp} // ✅ Show error message
      />

      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <Button
          fullWidth
          variant="outlined"
          className='btn-default'
          onClick={onResendOTP}
          disabled={isLoading}
        >
          Resend OTP
        </Button>
        
        <Button
          fullWidth
          type="submit"
          variant="contained"
          className='btn-default'
          disabled={isLoading || !otpData.enteredOtp || otpData.enteredOtp.length !== 4}
        >
          {isLoading ? <CircularProgress size={24} /> : 'Verify & Register'}
        </Button>
      </Box>

      <Typography variant="body2" color="text.secondary" align="center">
        Didn't receive OTP? Check your mobile number and try resending.
      </Typography>
    </Box>
  );
};

export {OTPVerificationStep}